import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function NoRecordings() {
  const { t } = useTranslation();
  return (
    <Grid gap={2} display="flex" flexDirection="column" alignItems="center">
      <img src="/assets/icons/clipboard-remove.svg" alt="clipboard-remove" height={72} width={72} />
      <Typography variant="title2Bold" color="primary">
        {t('notes.noRecordings')}
      </Typography>
      <Typography variant="bodyRegular" color="primary" textAlign="center">
        {t('notes.noAvailableRecordings')}
      </Typography>
    </Grid>
  );
}

export default NoRecordings;
